import resourceConfig from '../config';

export default {
    resources: {
        [resourceConfig.name]: {
            name: 'Отчет |||| Отчеты',
            title: 'Количество неиспользованных КМ в разрезе GTIN',
            openAction: 'Открыть',
            executeAction: 'Сформировать',
            successMessage: 'Формирование файла в процессе. Готовый файл можно получить в журнале "Файлы выгрузки"',
            errorMessage: 'Ошибка при запуске формирования отчёта',
            fields: {
                status: 'Статус',
                emissionType: 'Тип эмиссии',
            },
            status: {
                APPLIED: 'Нанесен',
                EMITTED: 'Выпущен',
            },
        }
    }
};
